import { Building2, Network, UserCog, Users } from "lucide-react";

export const PEOPLE_PATHS = {
  hub: "/employees",
  hierarchy: "/org-hierarchy",
  orgStructure: "/org-structure",
  lifecycle: "/employee-lifecycle",
};

export const PEOPLE_MODULES = [
  {
    id: "employees",
    label: "Employee Management",
    desc: "Add, edit, search & bulk import workforce records",
    icon: Users,
    path: PEOPLE_PATHS.hub,
    roles: ["admin", "hr"],
  },
  {
    id: "hierarchy",
    label: "People Hierarchy",
    desc: "Assign, explore & edit who reports to whom",
    icon: Network,
    path: PEOPLE_PATHS.hierarchy,
    roles: ["admin", "hr", "manager"],
  },
  {
    id: "orgStructure",
    label: "Organisation Structure",
    desc: "Location → Department → Designation → Employee map",
    icon: Building2,
    path: PEOPLE_PATHS.orgStructure,
    roles: ["admin"],
  },
  {
    id: "lifecycle",
    label: "Employee Lifecycle",
    desc: "Onboarding, offboarding, templates & exit analytics",
    icon: UserCog,
    path: PEOPLE_PATHS.lifecycle,
    roles: ["admin", "hr", "finance"],
  },
];

export function peopleModuleFromPath(pathname) {
  const p = String(pathname || "");
  if (p.startsWith(PEOPLE_PATHS.orgStructure)) return "orgStructure";
  if (p.startsWith(PEOPLE_PATHS.hierarchy)) return "hierarchy";
  if (p.startsWith(PEOPLE_PATHS.lifecycle)) return "lifecycle";
  if (p === PEOPLE_PATHS.hub || p.startsWith(`${PEOPLE_PATHS.hub}/`)) return "employees";
  return null;
}
